export default __webpack_public_path__ + "static/media/bg1.5b64b3f0.jpg";